export class CookbookRequestOption {
    Id_app: number;
    Id_session: number;
    ManualJSON: number;
    Signature: string;
    Controller: string;
    EntityId: number;
    Section: string;
    Method: string;
    ApiVersion: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cookbook-request-option.ts